export const STATUS = {
  ok: { label: "Activo", color: "#24834b", background: "#edf8f0" },
  partial: { label: "Falla parcial", color: "#a56306", background: "#fff7e8" },
  fail: { label: "Con fallo", color: "#c43434", background: "#fff0f0" },
  unknown: { label: "Sin información", color: "#627087", background: "#eef1f5" },
};
const normalize = (value) =>
  String(value ?? "")
    .trim()
    .toUpperCase();
export function statusKey(value) {
  const state = normalize(value);
  if (["SIN NOVEDAD", "COMERCIO ACTIVO"].includes(state)) return "ok";
  if (["FALLA PARCIAL DEL COMERCIO", "POSIBLE FALLO"].includes(state)) return "partial";
  if (state === "COMERCIO CON FALLO") return "fail";
  return "unknown";
}
export const parentState = (item, tipo) =>
  tipo === "peajes" ? item.estado_operador : item.estado_comercio;
export function recordStatus(item, tipo) {
  const device =
    tipo === "eds"
      ? item.estado_antena
      : tipo === "peajes"
      ? item.estado_comercio
      : item.estado_terminal;
  const state = statusKey(device);
  if (state === "partial" && statusKey(parentState(item, tipo)) === "fail") return "fail";
  return state;
}
export const rawDate = (item, tipo) => (tipo === "eds" ? item.ultima_lectura : item.ultima_entrada);
const timestamp = (value) => {
  const time = value == null || value === "" ? NaN : new Date(value).getTime();
  return Number.isFinite(time) ? time : -Infinity;
};
export function formatDate(value) {
  if (timestamp(value) === -Infinity) return "Sin información";
  return new Intl.DateTimeFormat("es-CO", {
    timeZone: "America/Bogota",
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}
export const formatMinutes = (value) =>
  value == null || value === "" || !Number.isFinite(Number(value))
    ? "Sin información"
    : `${Number(value).toLocaleString("es-CO", { maximumFractionDigits: 2 })} min`;

export function groupDashboard(records, tipo) {
  const groups = new Map();
  records.forEach((item) => {
    const name = (tipo === "peajes" ? item.operador : item.comercio) || "Sin identificar";
    if (!groups.has(name)) groups.set(name, { id: name, name, records: [] });
    groups.get(name).records.push(item);
  });
  return Array.from(groups.values(), (group) => {
    // Una terminal/antena/peaje puede aparecer varias veces. Se conserva su lectura más reciente.
    const devices = new Map();
    group.records.forEach((item, index) => {
      const identity =
        tipo === "eds"
          ? [item.reader, item.antena]
          : [tipo === "peajes" ? item.comercio : item.terminalname];
      const key = identity.some((value) => value != null && value !== "")
        ? JSON.stringify(identity)
        : `unknown-${index}`;
      const previous = devices.get(key);
      if (!previous || timestamp(rawDate(item, tipo)) > timestamp(rawDate(previous, tipo)))
        devices.set(key, item);
    });
    const details = Array.from(devices.values());
    const parents = [...new Set(details.map((item) => statusKey(parentState(item, tipo))))];
    const statuses = details.map((item) => recordStatus(item, tipo));
    // El estado global declarado por el backend tiene prioridad si es consistente.
    // Si falta o se contradice, mostrar "Sin información" evita inventar un estado del comercio.
    const status = parents.length === 1 && parents[0] !== "unknown" ? parents[0] : "unknown";
    const latest = details.reduce(
      (current, item) =>
        timestamp(rawDate(item, tipo)) > timestamp(rawDate(current || {}, tipo)) ? item : current,
      null
    );
    return {
      ...group,
      records: details,
      status,
      total: details.length,
      active: statuses.filter((value) => value === "ok").length,
      last: latest ? rawDate(latest, tipo) : null,
      elapsed: latest?.minutos_desde_ultima,
    };
  }).sort(
    (a, b) =>
      ({ fail: 0, partial: 1, unknown: 2, ok: 3 }[a.status] -
        { fail: 0, partial: 1, unknown: 2, ok: 3 }[b.status] || a.name.localeCompare(b.name, "es"))
  );
}
